module.exports = __webpack_public_path__ + "img/eb6178d.png";